module.exports = __webpack_public_path__ + "img/samy-halim-martin-night.e87f7cd.jpg";